"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const OsmosysDiv_1 = require("../utils/OsmosysDiv");
const OsmosysIcon_1 = require("../art/OsmosysIcon");
exports.OsmosysLoadingState = () => {
    return (react_1.default.createElement(OsmosysDiv_1.OsmosysDiv, { flexColCenteredFilled: true },
        react_1.default.createElement(OsmosysDiv_1.OsmosysDiv, { flexRowCentered: true },
            react_1.default.createElement(OsmosysIcon_1.OsmosysIcon, { osysIcon: "spinner", spin: true, size: "2x" }))));
};
//# sourceMappingURL=OsmosysLoadingState.js.map